import UITabs from 'atoms/UITabs';
import Organization from 'molecules/Organization';
import Team from 'pages/Team';
import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { getCanViewOrganizationCharts, getClientid } from 'redux/selectors';
import { MAIN_CLIENT_ID } from 'common/Constants';

function MyTeam() {
    const [activeTab, setActiveTab] = useState(1);
    const canViewOrganizationCharts = useSelector(getCanViewOrganizationCharts);
    const clientId = useSelector(getClientid);

    const items = [
        {
            id: 1,
            label: "List",
            component: <Team />
        },
        ...(canViewOrganizationCharts ? [{
            id: 2,
            label: "Office Org Chart",
            component: <Organization type="office" team={true}/>
        }] : []),
        ...(canViewOrganizationCharts && clientId === MAIN_CLIENT_ID ? [{
            id: 3,
            label: "Regional Org Chart",
            component: <Organization type="regional" team={true}/>
        }] : []),

    ]
    const handleTabChange = (newValue) => {
        setActiveTab(newValue);
    };

  return (
    <div>
        {/* <h5>My Team Member</h5> */}
        <UITabs items={items} activeTab={activeTab} onTabChange={handleTabChange} />
    </div>
  )
}

export default MyTeam
